<fgb-navigation-indicator></fgb-navigation-indicator>
<fgb-popup-notification></fgb-popup-notification>

<fgb-nav-bar></fgb-nav-bar>
<fgbcl-notification-toast></fgbcl-notification-toast>

<div id="main">
  <router-outlet></router-outlet>
</div>

<fgb-footer></fgb-footer>
